import { Link } from "react-router-dom";
import { formatDate } from "../../../utils/date";
import { cx } from "../../../utils/classNames";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Dashboard.module.css";
import { toMyViewPath } from "../../../utils/legacyLinks";

const SEVERITY = {
  danger: { className: ui.alertDanger, icon: "bi-exclamation-octagon" },
  warning: { className: ui.alertWarning, icon: "bi-exclamation-triangle" },
  info: { className: ui.alertInfo, icon: "bi-info-circle" },
};

// Extra detail under the message, from `meta` (when the server sends it).
const getDetail = (item) => {
  if (item.meta?.reason) return `Reason: ${item.meta.reason}`;
  if (item.type === "MISSING_CHECKOUT" && item.meta?.dates?.length > 1) {
    return item.meta.dates.map(formatDate).join(", ");
  }
  return null;
};

// Already sorted danger → warning → info by the server; [] means all set.
const ActionItemsCard = ({ items }) => {
  if (!items.length) {
    return (
      <div className={styles.allSet}>
        <span className={styles.allSetTitle}>🎉 You're all set</span>
        <span>Nothing needs your attention right now.</span>
      </div>
    );
  }

  return (
    <ul className={styles.actionList}>
      {items.map((item) => {
        const severity = SEVERITY[item.severity] ?? SEVERITY.info;
        const detail = getDetail(item);

        return (
          <li key={item.type}>
            <Link
              to={toMyViewPath(item.link)}
              className={cx(styles.actionItem, severity.className)}
            >
              <i className={`bi ${severity.icon}`}></i>
              <span className={styles.actionText}>
                <span className={styles.actionMessage}>{item.message}</span>
                {detail && <div className={styles.actionMeta}>{detail}</div>}
              </span>
              <i className="bi bi-chevron-right"></i>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default ActionItemsCard;
